import React from "react";
import { getYear } from "@rentiohq/shared/dist/utils/date-fns.utils";
import * as S from "./Page.styles";
import AppBanner from "../AppBanner";
import ProfileMenu from "../ProfileMenu";
import images from "../../assets";

const YEAR = getYear(new Date());

interface IProps {
  withScroll?: boolean;
  backgroundColor?: string;
}

class Page extends React.Component<IProps> {
  // Render
  public render = () => (
    <S.Wrap>
      <S.BackgroundImageLeftWrap>
        <S.BackgroundImageLeft src={images.IMG_BACKGROUND_LEFT} />
      </S.BackgroundImageLeftWrap>
      <S.BackgroundImageRightWrap>
        <S.BackgroundImageRight src={images.IMG_BACKGROUND_RIGHT} />
      </S.BackgroundImageRightWrap>
      <S.InnerWrap>{this.renderContent()}</S.InnerWrap>
      {/*
      // FIXME: Connected component types
      // @ts-ignore */}
      <ProfileMenu />
    </S.Wrap>
  );

  private renderContent = () => {
    const { backgroundColor, children } = this.props;

    return (
      <S.ContentWrap backgroundColor={backgroundColor}>
        <div>
          <S.RentioLogoWrap onClick={this.handlePressRentioLogo}>
            <S.RentioLogo src={images.IMG_RENTIO_LOGO} />
          </S.RentioLogoWrap>
        </div>
        <AppBanner />
        <S.ChildrenWrap>{children}</S.ChildrenWrap>
        <div>
          <S.CopyrightWrap>
            <S.RentioCopyrightLogo src={images.IMG_RENTIO_LOGO_COPYRIGHT} />
            <S.CopyrightYear>{`© ${YEAR}`}</S.CopyrightYear>
          </S.CopyrightWrap>
        </div>
      </S.ContentWrap>
    );
  };

  // Event handlers
  private handlePressRentioLogo = () => {
    const url = "https://rentio.be";
    window.open(url, "_blank");
  };
}

export default Page;
